import api from "@/api/partners";
//  PARTNER ACTION

//  CREATE PARTNER
const createPartner = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createPartner(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  READ PARTNER

const readPartner = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readPartner(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

const readPartners = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .readPartners(payload)
      .then(response => {
        if (response.status === "OK") {
          context.commit("UPDATE_PARTNERS", response.data);
        }
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  UPDATE PARTNER
const updatePartner = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updatePartner(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

//  DELETE PARTNER
const deletePartner = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deletePartner(payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
export default {
  createPartner,
  readPartner,
  readPartners,
  updatePartner,
  deletePartner
};
